import { render, staticRenderFns } from "./firsix.vue?vue&type=template&id=5efa1781&scoped=true&"
import script from "./firsix.vue?vue&type=script&lang=js&"
export * from "./firsix.vue?vue&type=script&lang=js&"
import style0 from "./firsix.vue?vue&type=style&index=0&id=5efa1781&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5efa1781",
  null
  
)

export default component.exports